import { ActorType, AuditPolicy, AuthenticationAssuranceLevel, ConcurrencyPolicy, IdempotencyPolicy, PrivacyClassification, ScopeType, } from './operation.js';
export const SUSPENSE_CASH_CASE_CREATE = 'reconciliation.suspense-cash.create';
export const SUSPENSE_CASH_CASE_LIST = 'reconciliation.suspense-cash.list';
export const SUSPENSE_CASH_RESOLUTION_REQUEST = 'reconciliation.suspense-cash.resolution-request';
export const SUSPENSE_CASH_RESOLUTION_APPROVE = 'reconciliation.suspense-cash.resolution-approve';
export const SUSPENSE_CASH_REOPEN_REQUEST = 'reconciliation.suspense-cash.reopen-request';
export const SUSPENSE_CASH_REOPEN_APPROVE = 'reconciliation.suspense-cash.reopen-approve';
function suspenseOperation(id, name, options = {}) {
    const readOnly = options.readOnly ?? false;
    const translationKey = {
        [SUSPENSE_CASH_CASE_CREATE]: 'caseCreate',
        [SUSPENSE_CASH_CASE_LIST]: 'caseList',
        [SUSPENSE_CASH_RESOLUTION_REQUEST]: 'resolutionRequest',
        [SUSPENSE_CASH_RESOLUTION_APPROVE]: 'resolutionApprove',
        [SUSPENSE_CASH_REOPEN_REQUEST]: 'reopenRequest',
        [SUSPENSE_CASH_REOPEN_APPROVE]: 'reopenApprove',
    }[id];
    return {
        id,
        name,
        labelKey: `operations.reconciliation.suspenseCash.${translationKey}.label`,
        descriptionKey: `operations.reconciliation.suspenseCash.${translationKey}.description`,
        permission: readOnly ? 'reconciliation:view' : 'reconciliation:create',
        permissionId: readOnly
            ? 'organization:reconciliation:read'
            : 'organization:reconciliation:create',
        module: 'RECONCILIATION',
        requiredModules: ['INVESTMENT', 'ACCOUNTING', 'RECONCILIATION'],
        requiresEntitledModule: true,
        requiredAal: AuthenticationAssuranceLevel.AAL2,
        scopeTypes: [ScopeType.ORGANIZATION, ScopeType.BRANCH],
        allowedScopeKinds: ['ORGANIZATION', 'BRANCH'],
        allowedPersonas: ['ORG_ADMIN'],
        ownershipPolicy: 'ACTIVE_ORGANIZATION',
        requestedScope: {
            organizationId: [{ source: 'query', field: 'organizationId' }],
            branchId: [{ source: 'query', field: 'branchId' }],
        },
        forcesClientScope: false,
        makerCheckerRequired: options.makerChecker ?? false,
        idempotencyPolicy: readOnly ? IdempotencyPolicy.NOT_APPLICABLE : IdempotencyPolicy.REQUIRED,
        concurrencyPolicy: readOnly ? ConcurrencyPolicy.NONE : ConcurrencyPolicy.OPTIMISTIC,
        auditPolicy: readOnly ? AuditPolicy.READ : AuditPolicy.SENSITIVE,
        privacyClassification: PrivacyClassification.RESTRICTED,
        telemetryId: id,
        allowedActorTypes: [ActorType.USER],
        httpMethods: [readOnly ? 'GET' : 'POST'],
        isReadOnly: readOnly,
        isFinancial: true,
        supportDelegationEligible: false,
        delegationPolicy: 'NOT_ALLOWED',
        accessType: readOnly ? 'READ' : 'WRITE',
    };
}
export const SUSPENSE_CASH_OPERATIONS = {
    [SUSPENSE_CASH_CASE_CREATE]: suspenseOperation(SUSPENSE_CASH_CASE_CREATE, 'Ingest Unidentified Cash Case'),
    [SUSPENSE_CASH_CASE_LIST]: suspenseOperation(SUSPENSE_CASH_CASE_LIST, 'List Unidentified Cash Cases', { readOnly: true }),
    [SUSPENSE_CASH_RESOLUTION_REQUEST]: suspenseOperation(SUSPENSE_CASH_RESOLUTION_REQUEST, 'Request Unidentified Cash Resolution', { makerChecker: true }),
    [SUSPENSE_CASH_RESOLUTION_APPROVE]: suspenseOperation(SUSPENSE_CASH_RESOLUTION_APPROVE, 'Approve Unidentified Cash Resolution', { makerChecker: true }),
    [SUSPENSE_CASH_REOPEN_REQUEST]: suspenseOperation(SUSPENSE_CASH_REOPEN_REQUEST, 'Request Unidentified Cash Reopening', { makerChecker: true }),
    [SUSPENSE_CASH_REOPEN_APPROVE]: suspenseOperation(SUSPENSE_CASH_REOPEN_APPROVE, 'Approve Unidentified Cash Reopening', { makerChecker: true }),
};
